import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { AddressComponent } from './address/address.component';
import { ButtonComponent } from './button/button.component';
import { InputGeneralComponent } from './input-general/input-general.component';
import { KonfirmasiHapusComponent } from './state/konfirmasi-hapus/konfirmasi-hapus.component';
import { KonfirmasiPrimaryComponent } from './state/konfirmasi-primary/konfirmasi-primary.component';
import { PenyimpanganComponent } from './state/penyimpangan/penyimpangan.component';
import { PreviewImageNotokenComponent } from './preview-image-notoken/preview-image-notoken.component';
import { PreviewPhotoLaporanComponent } from './preview-photo-laporan/preview-photo-laporan.component';
import { ChipMultiSelectComponent } from './chip-multi-select/chip-multi-select.component';
// import { CalendarModule } from 'ion2-calendar';

@NgModule({
  declarations: [
    HeaderComponent,
    AddressComponent,
    ButtonComponent,
    InputGeneralComponent,
    KonfirmasiHapusComponent,
    KonfirmasiPrimaryComponent,
    PenyimpanganComponent,
    PreviewImageNotokenComponent,
    PreviewPhotoLaporanComponent,
    ChipMultiSelectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    // CalendarModule
  ],
  exports: [
    HeaderComponent,
    AddressComponent,
    ButtonComponent,
    InputGeneralComponent,
    KonfirmasiHapusComponent,
    KonfirmasiPrimaryComponent,
    PenyimpanganComponent,
    PreviewImageNotokenComponent,
    PreviewPhotoLaporanComponent,
    ChipMultiSelectComponent
  ]
})
export class SharedModule { }
